import InfoPanels from "./info-panels";
export default InfoPanels;
